import * as React from "react";

// Apri dettaglio interattività: cerchio con "+" — sostituisce la
// vecchia icona "i". Stroke usa currentColor così l'icona eredita il
// colore dal parent (tipicamente la card prodotto o il manager).
const DetailIcon = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="9.5"
      cy="9.5"
      r="9"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
    />
    <line
      x1="4.38"
      y1="9.5"
      x2="14.62"
      y2="9.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
    />
    <line
      x1="9.5"
      y1="14.62"
      x2="9.5"
      y2="4.38"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
    />
  </svg>
);
export default DetailIcon;
